import classNames from "classnames";
import Modal from "../../../../components/common/Modal";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import PrimaryButton from "../../../../components/common/PrimaryButton";
import { useState } from "react";
import Spinner from "../../../../components/common/Spinner";

interface ISettlementConfirmationModalProps {
  handleClose: () => void;
  modalOpen: boolean;
  currentTotalValues: number;
  arbitratorAmount: number;
  waffyFees: number;
  handleConfirmSettlement: () => Promise<void>;
}

const SettlementConfirmationModal = ({
  handleClose,
  modalOpen,
  currentTotalValues,
  arbitratorAmount,
  waffyFees,
  handleConfirmSettlement,
}: ISettlementConfirmationModalProps) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const onConfirm = async () => {
    setLoading(true);
    await handleConfirmSettlement();
    setLoading(false);
  };

  return (
    <Modal visible={modalOpen} onCancel={handleClose}>
      <div className={classNames(styles.container)}>
        <div className={styles.headerContainer}>
          <h1 className={styles.title}>{t("lbl_confirm_settlement_title")} </h1>
          <p className={styles.description}>
            {t("lbl_confirm_settlement_description")}
          </p>
        </div>

        <div className={styles.breakdownContainer}>
          <div className={styles.breakDownContent}>
            <p className={styles.label}>{t("lbl_total_settled_amount")}</p>
            <p className={styles.amount}>{`${currentTotalValues} ${t(
              "lbl_saudi_currency"
            )}`}</p>
          </div>
          <div className={styles.breakDownContent}>
            <p className={styles.label}>{t("lbl_value_assigned_to_you")}</p>
            <p className={styles.amount}>{`${arbitratorAmount} ${t(
              "lbl_saudi_currency"
            )}`}</p>
          </div>
        </div>

        <div
          className={styles.breakdownContainer}
          style={{
            backgroundColor:
              arbitratorAmount - waffyFees < 0 ? "#FFF5F5" : "#F0FAF3",
          }}>
          <div className={styles.breakDownContent}>
            <p className={styles.label}>{`${t("lbl_waffy_fees_amount")}${
              arbitratorAmount - waffyFees < 0
                ? t("lbl_deducted_from_your_balance")
                : ""
            }`}</p>
            <p className={styles.amount}>{`${waffyFees} ${t(
              "lbl_saudi_currency"
            )}`}</p>
          </div>
        </div>

        <PrimaryButton
          onClick={onConfirm}
          disabled={loading}
          style={{
            width: "100%",
            height: "44px",
            borderRadius: "8px",
            textAlign: "center",
            whiteSpace: "nowrap",
            fontSize: "14px",
            lineHeight: "100%",
            fontWeight: 500,
            alignSelf: "flex-end",
            marginTop: "auto",
            background: loading ? "#E2E5EE" : "#0D44AD",
          }}>
          {loading ? <Spinner /> : t("lbl_confirm")}
        </PrimaryButton>
      </div>
    </Modal>
  );
};

export default SettlementConfirmationModal;
